import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Portal } from "@air/primitive-portal";
import noop from "lodash/noop";
import { createContext, memo, useContext, useMemo, useState } from "react";
const defaultValue = {
    setActionBar: noop,
    setActionBarXOffset: noop,
    actionBar: null
};
const ActionBarContext = /*#__PURE__*/ createContext(defaultValue);
export const ActionBarProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [actionBarOffset, setActionBarXOffset] = useState(0);
    const [actionBar, setActionBar] = useState(null);
    const value = useMemo(()=>({
            setActionBar,
            setActionBarXOffset,
            actionBar
        }), [
        actionBar
    ]);
    return /*#__PURE__*/ _jsxs(ActionBarContext.Provider, {
        value: value,
        children: [
            children,
            !!actionBar && /*#__PURE__*/ _jsx(Portal, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "pointer-events-none fixed bottom-0 right-0 z-portal m-0 flex flex-col items-center overflow-hidden px-0 py-3",
                    style: {
                        width: "calc(100% - ".concat(actionBarOffset, "px)")
                    },
                    children: actionBar
                })
            })
        ]
    });
});
ActionBarProvider.displayName = "ActionBarProvider";
export function useActionBar() {
    const context = useContext(ActionBarContext);
    if (context === defaultValue) {
        throw "useActionBar used outside of ActionBarProvider";
    }
    return context;
}
